/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */

import { css, html, LitElement } from 'lit-element';
import '../../styles';
/**
 * @prop {String} direction - Defines the direction the components are arranged. Possible values are `column` or `row`.
 * @prop {String} spacing - Defines the spacing between the components. Possible values are `s` (4px), `m` (8px) or `l` (16px).
 */
export class SHWrapper extends LitElement {
  static get properties() {
    return {
      direction: { type: String, reflect: true },
      spacing: { type: String, reflect: true },
    };
  }

  static get styles() {
    return [
      css`
        :host {
          display: flex;
          flex-wrap: wrap;
        }

        /* direction */
        :host([direction='row']) {
          flex-direction: row;
        }

        :host([direction='column']) {
          flex-direction: column;
        }

        /* spacing */
        /* none */
        :host([spacing='none']) {
          width: 100%;
        }

        /* xs */
        :host([spacing='xs']) {
          width: calc(100% + 0.125rem);
          margin: -0.0625rem;
        }

        :host([spacing='xs']) ::slotted(*) {
          margin: 0.0625rem;
        }

        /* s */
        :host([spacing='s']) {
          width: calc(100% + 0.25rem);
          margin: -0.125rem;
        }

        :host([spacing='s']) ::slotted(*) {
          margin: 0.125rem;
        }

        /* m */
        :host([spacing='m']) {
          width: calc(100% + 0.5rem);
          margin: -0.25rem;
        }

        :host([spacing='m']) ::slotted(*) {
          margin: 0.25rem;
        }

        /* l */
        :host([spacing='l']) {
          width: calc(100% + 1rem);
          margin: -0.5rem;
        }

        :host([spacing='l']) ::slotted(*) {
          margin: 0.5rem;
        }
      `,
    ];
  }

  render() {
    return html` <slot></slot> `;
  }

  constructor() {
    super();
    this.direction = 'row';
    this.spacing = 's';
  }
}

customElements.define('sh-wrapper', SHWrapper);
